import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  margin-bottom: 20px;
  margin-left: 20px;
`;

export const PageWrapperDiv = styled.div`
  padding: 10px 15px;
  max-height: calc(100vh - 64px);
  overflow-y: auto;
`;

export const ListWrapperDiv = styled.div`
  padding: 2%;
`;

export const DetailWrapperDiv = styled.div`
  padding: 2% 3%;
  text-align: center;
`;

export const ReportDetailWrapperDiv = styled.div`
  padding-block: 2%;
  text-align: center;
`;

export const ReportColumnWrapperDiv = styled.div`
  border-radius: 5px;
  padding: 20px;
  height: 100%;
  //box-shadow: 3px 3px 20px -6px rgba(0, 0, 0, 0.3);
`;
